export default {
  namespaced:true,
  state:{
    row:null ,
  },
  mutations:{
    // 设置token
    SET_ROW(state,row){
      state.row = row
      console.log(row)
    },
  },
  actions:{

  },
  getters:{

  },
}



// WEBPACK FOOTER //
// ./src/store/modules/CK.js